const initializeSignalFlow = (root = document) => {
  root.querySelectorAll('[data-signal-page]').forEach((page) => {
    if (page.dataset.signalInitialized === 'true') return;
    page.dataset.signalInitialized = 'true';

    const form = page.querySelector('.th-signal-page__form');
    const input = form?.querySelector('input[type="email"]');
    const clientError = form?.querySelector('[data-signal-client-error]');

    if (form && input && clientError) {
      form.addEventListener('submit', (event) => {
        if (input.validity.valid) return;
        event.preventDefault();
        clientError.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      });

      input.addEventListener('input', () => {
        if (!input.validity.valid) return;
        clientError.hidden = true;
        input.removeAttribute('aria-invalid');
      });
    }

    const success = page.querySelector('[data-signal-success]');
    const redirect = success?.dataset.signalRedirect;
    if (success && redirect) window.location.replace(redirect);
  });
};

initializeSignalFlow();

document.addEventListener('shopify:section:load', (event) => initializeSignalFlow(event.target));
